/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type AccessDeniedErrorResponseStatusCode = typeof AccessDeniedErrorResponseStatusCode[keyof typeof AccessDeniedErrorResponseStatusCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccessDeniedErrorResponseStatusCode = {
  NUMBER_403: 403,
} as const;
